import {
    Component,
    Input,
    Output,
    OnChanges,
    ElementRef,
    ViewChild,
    EventEmitter,
    AfterViewInit,
    ChangeDetectionStrategy,
    SimpleChanges
} from '@angular/core';
import { trimLabel } from '@swimlane/ngx-charts';
// import { reduceTicks } from './ticks.helper';
// import { roundedRect } from '../../common/shape.helper';

@Component({
    selector: 'g[ngx-charts-y-axis-ticks-custom]',
    template: `
      <svg:g #ticksel>
        <svg:g *ngFor="let tick of ticks; let i = index" class="tick"
          [attr.transform]="transform(tick)" >
          <title>{{tickFormat(tick)}}</title>
          <svg:text *ngIf="ticks2[i].killer && !labelShow" [class.red-shadow]="this.hilightText[i]" style="stroke:#ff5454;stroke-width:0.6em;stroke-opacity:0.3;"
            [attr.dy]="dy"
            [attr.x]="x1"
            [attr.y]="y1"
            [attr.text-anchor]="textAnchor"
            [style.font-size]="'12px'">
            <tspan x="0" [attr.dy]="'0'" [matTooltip]="tick">{{splitLines(tick, (labelShow?45:25))}}</tspan>
          </svg:text>
          <svg:text *ngIf="ticks2[i].killer && labelShow" [class.red-shadow]="this.hilightText[i]"
            style="stroke:#ff5454;stroke-width:0.6em;stroke-opacity:0.3;"
            [attr.dy]="dy"
            [attr.x]="x1"
            [attr.y]="y1"
            [attr.text-anchor]="textAnchor"
            [style.font-size]="'12px'">
            <tspan *ngFor="let line of splitLines(tick, 76); let i = index" x="0" [attr.dy]="i === 0 ? '0' : '1.2em'">{{line}}</tspan>
          </svg:text>
          <svg:text *ngIf="!labelShow || true" [class.red-shadow]="this.hilightText[i]"
            stroke-width="0.01"
            [attr.dy]="dy"
            [attr.x]="x1"
            [attr.y]="y1"
            [attr.text-anchor]="textAnchor"
            [style.font-size]="'12px'">
            <tspan x="0" [attr.dy]="'0'" [matTooltip]="tick">{{splitLines(tick, 76)}}</tspan>
          </svg:text>
          <svg:text *ngIf="labelShow && false" [class.red-shadow]="this.hilightText[i]"
            stroke-width="0.01"
            [attr.dy]="dy"
            [attr.x]="x1"
            [attr.y]="y1"
            [attr.text-anchor]="textAnchor"
            [style.font-size]="'12px'">
            <tspan *ngFor="let line of splitLines(tick, 76); let i = index" x="0" [attr.dy]="i === 0 ? '0' : '1.2em'">{{line}}</tspan>
          </svg:text>
        </svg:g>
      </svg:g>
      <svg:path *ngIf="referenceLineLength > 1 && refMax && refMin && showRefLines"
        class="reference-area"
        [attr.d]="referenceAreaPath"
        [attr.transform]="gridLineTransform()"
      />
      <svg:g *ngFor="let tick of ticks"
        [attr.transform]="transform(tick)">
        <svg:g
          *ngIf="showGridLines"
          [attr.transform]="gridLineTransform()">
          <svg:line *ngIf="orient === 'left'"
            class="gridline-path gridline-path-horizontal"
            x1="0"
            [attr.x2]="gridLineWidth" />
          <svg:line *ngIf="orient === 'right'"
            class="gridline-path gridline-path-horizontal"
            x1="0"
            [attr.x2]="-gridLineWidth" />
        </svg:g>
      </svg:g>
  
      <svg:g *ngFor="let refLine of referenceLines">
        <svg:g *ngIf="showRefLines" [attr.transform]="transform(refLine.value)">
          <svg:line class="refline-path gridline-path-horizontal"
            x1="0"
            [attr.x2]="gridLineWidth"
            [attr.transform]="gridLineTransform()"/>
          <svg:g *ngIf="showRefLabels">
            <title>{{tickFormat(refLine.value)}}</title>
            <svg:text
              class="refline-label"
              [attr.dy]="dy"
              [attr.y]="-6"
              [attr.x]="gridLineWidth"
              [attr.text-anchor]="textAnchor" >
              {{refLine.name}}
            </svg:text>
          </svg:g>
        </svg:g>
      </svg:g>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class YAxisTicksCustomComponent implements OnChanges, AfterViewInit {

    @Input() scale;
    @Input() hilightText;
    @Input() scale2;
    @Input() orient;
    @Input() tickArguments = [5];
    @Input() tickValues;
    @Input() tickStroke = '#ccc';
    @Input() tickFormatting;
    @Input() showGridLines = false;
    @Input() gridLineWidth;
    @Input() height;
    @Input() referenceLines;
    @Input() labelShow: boolean = false;
    @Input() showRefLabels: boolean = false;
    @Input() showRefLines: boolean = false;

    @Output() dimensionsChanged = new EventEmitter();

    innerTickSize: any = 6;
    tickPadding: any = 3;
    tickSpacing: any;
    verticalSpacing: number = 20;
    textAnchor: any = 'middle';
    dy: any;
    x1: any;
    x2: any;
    y1: any;
    y2: any;
    adjustedScale: any;
    transform: (o: any) => string;
    tickFormat: (o: any) => string;
    ticks: any;
    ticks2: any;
    width: number = 0;
    outerTickSize: number = 6;
    rotateLabels: boolean = false;
    trimLabel: any;
    refMax: number;
    refMin: number;
    referenceLineLength: number = 0;
    referenceAreaPath: string;

    @ViewChild('ticksel') ticksElement: ElementRef;

    constructor() {
        this.trimLabel = trimLabel;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.updateDims());
    }

    // alowShadow(index){
    //     return this.hilightText[index];
    // }

    splitLines(text, maxTextWidth) {
        // console.log("splitLines", text, maxTextWidth)
        // if (!text) return [];
        // const words = text.split(' ');
        // const lastWord = words[words.length - 1];
        // let lineWidth = 0;
        // let thisLine = '';
        // const allLines = new Array();

        // for (let i = 0; i < words.length; i++) {
        //     const word = words[i];
        //     thisLine = thisLine.concat(word + ' ');
        //     lineWidth = thisLine.length;
        //     if (word !== lastWord) {
        //         const nextWord = words[i + 1];
        //         if (lineWidth + nextWord.length >= maxTextWidth) {
        //             addToAllLines(thisLine);
        //         } else if (word === '~') {
        //             addToAllLines(' ');
        //         } else if (nextWord === '~') {
        //             addToAllLines(thisLine);
        //         }
        //     } else {
        //         addToAllLines(thisLine);
        //         // console.log("allLines", allLines)
                
        //     }
        // }

        // function addToAllLines(text) {
        //     allLines.push(text);
        //     thisLine = '';
        //     lineWidth = 0;
        // }
        let length = text.toString().length;
        let allLines;
        if(length > maxTextWidth){
            allLines = text.slice(0,maxTextWidth) + '...';
        }else{
            allLines = text;
        }
        return allLines;
    }

    updateDims(): void {
        const width = parseInt(this.ticksElement.nativeElement.getBoundingClientRect().width, 10);
        if (width !== this.width) {
            this.width = width;
            this.dimensionsChanged.emit({ width });
            setTimeout(() => this.updateDims());
        }
    }

    update(): void {
        let scale;
        const sign = this.orient === 'top' || this.orient === 'right' ? -1 : 1;
        this.tickSpacing = Math.max(this.innerTickSize, 0) + this.tickPadding;

        scale = this.scale;
        this.ticks = this.getTicks();

        if (this.tickFormatting) {
            this.tickFormat = this.tickFormatting;
        } else if (scale.tickFormat) {
            this.tickFormat = scale.tickFormat.apply(scale, this.tickArguments);
        } else {
            this.tickFormat = function (d) {
                if (d.constructor.name === 'Date') {
                    return d.toLocaleDateString();
                }
                return d.toLocaleString();
            };
        }

        this.adjustedScale = scale.bandwidth ? function (d) {
            return scale(d) + scale.bandwidth() * 0.5;
        } : scale;

        if (this.showRefLines && this.referenceLines) {
            this.setReferencelines();
        }

        switch (this.orient) {
            case 'top':
                this.transform = function (tick) {
                    return 'translate(' + this.adjustedScale(tick) + ',0)';
                };
                this.textAnchor = 'middle';
                this.y2 = this.innerTickSize * sign;
                this.y1 = this.tickSpacing * sign;
                this.dy = sign < 0 ? '0em' : '.71em';
                break;
            case 'bottom':
                this.transform = function (tick) {
                    return 'translate(' + this.adjustedScale(tick) + ',0)';
                };
                this.textAnchor = 'middle';
                this.y2 = this.innerTickSize * sign;
                this.y1 = this.tickSpacing * sign;
                this.dy = sign < 0 ? '0em' : '.71em';
                break;
            case 'left':
                this.transform = function (tick) {
                    return 'translate(0,' + this.adjustedScale(tick) + ')';
                };
                this.textAnchor = 'end';
                this.x2 = this.innerTickSize * -sign;
                this.x1 = this.tickSpacing * -sign;
                this.dy = '.32em';
                break;
            case 'right':
                this.transform = function (tick) {
                    return 'translate(0,' + this.adjustedScale(tick) + ')';
                };
                this.textAnchor = 'start';
                this.x2 = this.innerTickSize * -sign;
                this.x1 = this.tickSpacing * -sign;
                this.dy = '.32em';
                break;
            default:
        }
        setTimeout(() => this.updateDims());
    }

    roundedRect(x, y, w, h, r, [tl, tr, bl, br]: boolean[]) {
        let retval = '';

        retval = `M${[x + r, y]}`;
        retval += `h${w - 2 * r}`;

        if (tr) {
            retval += `a${[r, r]} 0 0 1 ${[r, r]}`;
        } else {
            retval += `h${r}v${r}`;
        }

        retval += `v${h - 2 * r}`;

        if (br) {
            retval += `a${[r, r]} 0 0 1 ${[-r, r]}`;
        } else {
            retval += `v${r}h${-r}`;
        }

        retval += `h${2 * r - w}`;

        if (bl) {
            retval += `a${[r, r]} 0 0 1 ${[-r, -r]}`;
        } else {
            retval += `h${-r}v${-r}`;
        }

        retval += `v${2 * r - h}`;

        if (tl) {
            retval += `a${[r, r]} 0 0 1 ${[r, -r]}`;
        } else {
            retval += `v${-r}h${r}`;
        }

        retval += `z`;

        return retval;
    }

    setReferencelines(): void {
        this.refMin = this.adjustedScale(Math.min.apply(null, this.referenceLines.map(item => item.value)));
        this.refMax = this.adjustedScale(Math.max.apply(null, this.referenceLines.map(item => item.value)));
        this.referenceLineLength = this.referenceLines.length;

        this.referenceAreaPath = this.roundedRect(0, this.refMax, this.gridLineWidth, this.refMin - this.refMax,
            0, [false, false, false, false]);
    }

    reduceTicks(ticks, maxTicks) {
        if (ticks.length > maxTicks) {
            const reduced:any[] = [];
            const modulus = Math.floor(ticks.length / maxTicks);
            for (let i = 0; i < ticks.length; i++) {
                if (i % modulus === 0) {
                    reduced.push(ticks[i]);
                }
            }
            ticks = reduced;
        }

        return ticks;
    }

    getTicks(): any {
        let ticks;
        const maxTicks = this.getMaxTicks(20);
        const maxScaleTicks = this.getMaxTicks(50);

        if (this.tickValues) {
            ticks = this.tickValues;
        } else if (this.scale.ticks) {
            ticks = this.scale.ticks.apply(this.scale, [maxScaleTicks]);
        } else {
            ticks = this.scale.domain();
            ticks = this.reduceTicks(ticks, maxTicks);
            this.ticks2 = this.scale2;
        }

        return ticks;
    }

    getMaxTicks(tickHeight: number): number {
        return Math.floor(this.height / tickHeight);
    }

    tickTransform(tick): string {
        return `translate(${this.adjustedScale(tick)},${this.verticalSpacing})`;
    }

    gridLineTransform(): string {
        return `translate(5,0)`;
    }

}